// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_U30","cls2":"JJHomePageSearch-cls2_JS5 JJHomePageSearch-cls1_U30"};